import {LOGIN_START, LOGIN_SUCCESS, LOGIN_FAIL, LOGIN_RESET} from './constants';
import {LoginActions, LoginState} from './types';

const initialState: LoginState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: LoginActions,
): LoginState => {
  switch (action.type) {
    case LOGIN_START:
      return {
        ...initialState,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case LOGIN_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case LOGIN_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
